import React from 'react';
import TaskQueue from './TaskQueue';

/**
 * Consumer Xperience → Tasks: every task type, renewals included.
 *
 * Renewals keep their own menu entry for anyone who wants only those, but an
 * RM working their day shouldn't have to switch menus to see a renewal — and
 * when a notification arrives they shouldn't have to guess which list it
 * landed in. One queue, with Renewals as a type in the dropdown.
 */
const OtherTasksPage: React.FC = () => (
  <TaskQueue
    scope="all"
    title="My Tasks"
    subtitle="Every task type, renewals included — worked by urgency and SLA."
  />
);

export default OtherTasksPage;
